import { createFileRoute } from "@tanstack/react-router";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/forgot-password")({
  head: () => adminHead("Forgot Password | Admin", "Reset your admin dashboard password.", "/admin/forgot-password"),
  component: AdminForgotPassword,
});
